// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const RecentModelsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(13rem, 1fr));
  gap: 0.5rem;
  margin: 0;
  width: 100%;
  margin-bottom: 0.5rem;
`;
